/**
 * AM.One API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ReindexGitlabResolutionErrorBody { 
    status: ReindexGitlabResolutionErrorBody.StatusEnum;
    message: string;
    timestamp: string;
    error: ReindexGitlabResolutionErrorBody.ErrorEnum;
    path: string;
}
export namespace ReindexGitlabResolutionErrorBody {
    export const StatusEnum = {
        NUMBER_502: 502
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
    export const ErrorEnum = {
        GitlabDefaultBranchResolutionFailed: 'GITLAB_DEFAULT_BRANCH_RESOLUTION_FAILED'
    } as const;
    export type ErrorEnum = typeof ErrorEnum[keyof typeof ErrorEnum];
}


